export default function MatrimonyHomeHero() {
  return (
    <section className="relative h-[500px] overflow-hidden">
      {/* Background with overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/profile_h.png')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center text-white max-w-4xl mx-auto px-6">
          <h1 className="text-[48px] font-bold mb-2 bg-gradient-to-r from-white to-rose-200 bg-clip-text text-transparent">
            Find Your
          </h1>
          <h2 className="text-[36px] font-bold mb-8 bg-gradient-to-r from-rose-400 to-pink-400 bg-clip-text text-transparent">
            Perfect Match
          </h2>
          <p className="text-[20px] text-gray-200 max-w-2xl mx-auto leading-relaxed">
            Where hearts connect and love stories begin
          </p>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-rose-500/20 rounded-full blur-xl animate-pulse" />
      <div
        className="absolute bottom-20 right-10 w-32 h-32 bg-pink-500/20 rounded-full blur-xl animate-pulse"
        style={{ animationDelay: "1s" }}
      />
    </section>
  )
}
